module.exports = __webpack_public_path__ + "static/media/flatten.55647028.png";